<template>
  <div id="dashboardLogistics">
    <div class="headerContent">
      <div class="headerLeft">
        {{ timeInfo.currentTime }}&nbsp; {{ timeInfo.date }} &nbsp;{{ timeInfo.weekday }}
      </div>
      <div class="headerMiddle">
        市北高新起降场管理服务平台
      </div>
      <div class="headerRight">
        <div class="headerBtn" style="margin-right: 12px" @click="()=>{this.$router.push({path:'/home'})}">返回</div>
      </div>
    </div>
    <div class="videoWrap">
      <div  style="position: relative;width: 100%;height: 100%;">
        <!--        <div class="videoClose" @click="closeVideo">X</div>-->
        <!--        <div class="videoName">智汇园视频</div>-->
        <video   v-if="isShowVideo" id="video2" ref="video"  class="video-js vjs-default-skin" controls preload="auto" style="width: 99.6%;height: 99.6%">
        </video>
      </div>
    </div>
    <div v-if="!isShowVideo"
         class="mapWrap">
      <SecondMap
        @change-video="changeVideo"
        :showRightInfo="false"
        actionScope="anchorPads"
        :showBtns="true"
        :style="{display:isShowVideo?'none':'block'}"
        style="width: 100%; height: 100%;"
        showType="AirPath"
        ref="map"
      ></SecondMap>
    </div>
    <div class="contentWrap">
      <div class="leftContent">
        <div class="contentItem">
          <div class="itemTitle">
            <div class="itemTitleText">天气现象</div>
          </div>
          <div class="weatherWrap">
            <div class="weatherLeftTopTitleItem weatherTitleItemBox">
              <div class="weatherItemTitle">
                温度
              </div>
              <div class="weatherItemValue">
                {{weatherInfo.temp}}°c
              </div>
            </div>
            <div class="weatherLeftBottomTitleItem weatherTitleItemBox">
              <div class="weatherItemTitle">
                大气压强
              </div>
              <div class="weatherItemValue">
                {{weatherInfo.pressure}}mmHg
              </div>
            </div>
            <div class="weatherRightTopTitleItem weatherTitleItemBox">
              <div class="weatherItemTitle">
                湿度
              </div>
              <div class="weatherItemValue">
                {{weatherInfo.humidity}}
              </div>
            </div>
            <div class="weatherRightBottomTitleItem weatherTitleItemBox">
              <div class="weatherItemTitle">
                降雨
              </div>
              <div class="weatherItemValue">
                {{weatherInfo.rainfall}}mm
              </div>
            </div>
            <img id="weatherCorona" alt="" src="../../assets/img/dashboard/yuan_pan.png" class="weatherCorona"/>
            <div class="weatherCoronaCenter">
              <div>风向: {{weatherInfo.windDirection}}°</div>
              <div>风速： {{weatherInfo.windSpeed}}m/s</div>
            </div>
          </div>
        </div>
        <div class="contentItem66" >
          <div class="itemTitle">
            <div class="itemTitleText">飞行活动</div>
          </div>
          <div class="taskcontent_2d" >
            <div class="taskSearchBox" >
              <el-input
                placeholder="飞机型号,驾驶员,执照号,运营人,备注"
                v-model="searchTaskKeyWord "
                @keyup.enter.native="searchClick"
              >
                <i slot="suffix" class="el-input__icon el-icon-search" @click="searchClick"></i>
              </el-input>
            </div>

            <div class="listAll_2d" v-if="taskList.length !== 0">
              <div
                class="task-item_2d"
                v-for="item in taskList"
                :key="item.id"
                :title="'飞机号:'+item.uavSerial"
                @click="showPlanDetail(item)"
              >
                <div class="donePlan common" v-if="item.status==13||item.status==14">
                  <div  class="firstSpan" >{{ item.planSerial }}</div>
                  <div class="secondSpan" >{{ item.pilot }}</div>
                  <div class="thirdSpan" >
                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                  </div>
                  <div style="color: #ee3f3f">已执行</div>
                  <div class="itemDetail"></div>
                </div>
                <div class="prePlan common" v-if="item.status==0||item.status==1||item.status==2||item.status==3||item.status==4||item.status==5||item.status==6||item.status==7||item.status==8||item.status==9">
                  <div  class="firstSpan" >{{ item.planSerial }}</div>
                  <div class="secondSpan" >{{ item.pilot }}</div>
                  <div class="thirdSpan" >
                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                  </div>
                  <div style="color: #00aeff">待执行</div>
                  <div class="itemDetail"></div>
                </div>
                <div class="executePlan common" v-if="item.status==10||item.status==11||item.status==12">
                  <div  class="firstSpan" >{{ item.planSerial }}</div>
                  <div class="secondSpan" >{{ item.pilot }}</div>
                  <div class="thirdSpan" >
                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                  </div>
                  <div style="color: #00ffff">执行中</div>
                  <div class="itemDetail"></div>
                </div>
              </div>
            </div>
            <div class="emptyWrap" v-if="taskList.length == 0">
              <Empty/>
            </div>

          </div>
        </div>
      </div>

      <div class="rightContent">
        <div class="contentItem">
          <div class="itemTitle">
            <div class="itemTitleText">起落架次</div>
          </div>
          <div class="LandingsLandingsContentWrap">
            <div id="rightTopChart" class="lineChartWrap"></div>
          </div>
        </div>
        <div class="contentItem">
          <div class="itemTitle">
            <div class="itemTitleText">飞行监视</div>
          </div>
          <div class="map"  @click="switchVideo()">
            <div v-if="isShowVideo" class="mapContainer" :style="{display:isShowVideo?'block':'none'}">
              <SecondMap
                actionScope="anchorPads"
                :showBtns="false"
                style="width: 100%; height: 100%;"
                showType="AirPath"
                ref="map"
              ></SecondMap>
            </div>
            <div class="videoContainer"  v-if="!isShowVideo">
              <div style="position: relative;width: 100%;height: 100%">
                <!--                <div class="videoClose" @click="closeVideo">X</div>-->
                <!--                <div class="videoName">智汇园视频</div>-->
                <video  :data="1" v-if="!isShowVideo" ref="video" id="video2"   class="video-js vjs-default-skin" controls preload="auto" style="width: 99.6%;height: 99.6%">
                </video>
              </div>
            </div>
          </div>
        </div>
        <div class="contentItem">
          <div class="itemTitle">
            <div class="itemTitleText">飞行类型</div>
          </div>
          <div class="plan">
            <div class="one">
              <div class="planState1">
                <!-- <img src="../../assets/img/dashboard/data_chengse.png" alt=""> -->
                <div class="nums" >20</div>
                <div class="texts" >巡检</div>
              </div>
              <div class="planState2" style="margin-left: 20px;">
                <div class="nums" >32</div>
                <div class="texts" >物流</div>
              </div>
            </div>
            <div class="one">
              <div class="planState3">
                <div class="nums" >24</div>
                <div class="texts" >观光</div>
              </div>
              <div class="planState4" style="margin-left: 20px;">
                <div class="nums" >36</div>
                <div class="texts" >应急</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PlanDetail :taskForm="taskForm" :clickButton="clickButton"   @update:dialogVisible="updateDialogVisible" @closeForm="closeForm"
    ></PlanDetail>
  </div>
</template>

<script>
import echarts from "echarts";
import Hls from 'hls.js';
import planDetail from './components/PlanDetail.vue'
import MapContainer from "../MapContainer.vue";
import SecondMap from "./components/map2d.vue";
import PlanDetail from "../../common/PlanDetail.vue";
import  Empty from "../../common/Empty.vue"
export default {
  name: "logistics",
  data() {
    return {
      // 存储被点击的id
      startIds:[],
      changeIds:[],
      downIds:[],
      taskForm:{},
      clickButton:false,
      timeInfo: {
        currentTime: "10:04:06",
        date: "2020-10-20",
        weekday: "星期一"
      },
      searchTaskKeyWord:'',
      clickPlane: null,
      planeChartData: [],//飞机高度速度曲线数据
      planeDetailData: {},//飞机详情数据
      clickPlaneInfo: {},//显示实时飞行的飞机详情
      anchorInfo: [
        {
          id: '12309',
          inTime: '10:50:23 2024-12-2',
          outTime: '10:50:23  2024-12-2',
          type: '巡检'
        },
        {
          id: '12309',
          inTime: '10:50:23  2024-12-2',
          outTime: '10:50:23  2024-12-2',
          type: '物流'
        },
        {
          id: '12309',
          inTime: '10:50:23  2024-12-2',
          outTime: '10:50:23  2024-12-2',
          type: '观光'
        },
        {
          id: '12309',
          inTime: '10:50:23  2024-12-2',
          outTime: '10:50:23  2024-12-2',
          type: '巡检'
        }
      ],
      weatherInfo: {
        temp: NaN,
        pressure: NaN,
        humidity: NaN,
        rainfall: NaN,
        windDirection: NaN,
        windSpeed: NaN
      },
      rightTopChart: null,
      rightTopData: [],
      isDetailOpen: true,
      chartTimer: null,//chart定时器
      videoUrl: location.hostname === "192.168.205.13"?
        'http://192.168.205.13:9600/videoplayer/90/90/hls.m3u8' :
        location.hostname === "192.168.205.105"?
          'http://192.168.205.105:9600/videoplayer/90/90/hls.m3u8' :
          'http://220.248.31.148:9600/videoplayer/90/90/hls.m3u8',
      taskList:[],
      isShowVideo:true,
      hls:null,
    };
  },
  components: {
    planDetail,
    MapContainer,
    SecondMap,
    PlanDetail,
    Empty
  },
  mounted() {
    this.startVideo()
    this.setTime();
    this.getPageData()
    this.queryPlan()
    window.queryTaskTimer = setInterval(this.queryPlan, 10000);
    window.addEventListener('resize', this.handleResize, {passive: true});
    window.timer = setInterval(this.setTime, 1000);
    this.getWeatherInfo()
    window.weatherTimer = setInterval(()=>{
      this.getWeatherInfo()
    },10000)
  },
  beforeDestroy() {
    clearInterval(this.chartTimer);
    clearInterval(window.queryTaskTimer)
    this.chartTimer = null
    if (this.hls) {
      this.hls.destroy(); // 断开 HLS 连接
      this.hls = null;
    }
    if (window.weatherTimer) {
      clearInterval(window.weatherTimer);
      window.weatherTimer = null;
    }
  },
  methods: {
    changeVideo(url){
      this.videoUrl = location.hostname === "192.168.205.13"?'http://192.168.205.13:9600'+url :location.hostname === "192.168.205.105"?'http://192.168.205.105:9600'+url :'http://220.248.31.148:9600'+url,
        // this.videoUrl = !location.hostname.toString().includes('192.168.205') ?'http://220.248.31.148:9600'+url:"http://192.168.205.105:9600"+url
        this.hls.destroy();
      this.$nextTick(() => {
        if (!this.isShowVideo) {
          let ele = document.getElementById('video1')
          this.startVideo(ele)
        } else {
          let ele = document.getElementById('video2')
          this.startVideo(ele)
        }

      })
    },
    showPlanDetail(info) {
      this.taskForm = info
      this.clickButton = true
    },
    updateDialogVisible(newVal) {
      this.clickButton = newVal
    },
    closeForm(value) {
      this.clickButton = value
    },
    //起飞
    clickStart(info) {
      this.taskList.forEach(v => {
        if (v.id === info.id) {
          v.startChecked = !v.startChecked
        }
      })
      if (this.taskList.find(v => v.id === info.id).startChecked) {
        this.startIds.push(info.id)
      } else {
        this.startIds = this.startIds.filter(v => v !== info.id)
      }
      //Todo 逻辑判断
      // if(!this.startIds.includes(info.id)){
      if (true) {
        let data = {
          command: 1,
          orderID: info.planSerial,
          uasID: info.uavSerial,
          uasModel: info.uavModel
        };
        this.postJsonRequest("/uav-task-server/flightCommand/sendCommand", data).then(
          res => {
            if (res.status == 200) {
              if (res.data.code == 0) {
                this.$message.success({
                  message: "执行起飞指令成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function () {
                  }
                });
              } else {
                this.$message.error({
                  message: "执行起飞指令失败",
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function () {
                  }
                });
              }
            }
          }
        );
      } else {
        this.$message.error({
          message: "飞机正在飞行中执行起飞指令失败",
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function () {
          }
        });
      }
    },
    //暂停/恢复
    clickCircle(info) {
      this.taskList.forEach(v => {
        if (v.id === info.id) {
          v.changeChecked = !v.changeChecked
        }
      })
      if (this.taskList.find(v => v.id === info.id).changeChecked) {
        this.changeIds.push(info.id)
      } else {
        this.changeIds = this.changeIds.filter(v => v !== info.id)
      }
      let data = {
        command: !this.changeIds.includes(info.id) ? 8 : 11,
        orderID: info.planSerial,
        uasID: info.uavSerial,
        uasModel: info.uavModel
      };
      if (this.changeIds.includes(info.id)) {
        this.postJsonRequest("/uav-task-server/flightCommand/sendCommand", data).then(
          res => {
            if (res.status == 200) {
              if (res.data.code == 0) {
                this.$message.success({
                  message: "执行悬停指令成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function () {
                  }
                });
              } else {
                this.$message.error({
                  message: "执行悬停指令失败",
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function () {
                  }
                });
              }
            }
          }
        );
      } else {
        this.postJsonRequest("/uav-task-server/flightCommand/sendCommand", data).then(
          res => {
            if (res.status == 200) {
              if (res.data.code == 0) {
                this.$message.success({
                  message: "执行恢复指令成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function () {
                  }
                });
              } else {
                this.$message.error({
                  message: "执行恢复指令失败",
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function () {
                  }
                });
              }
            }
          }
        );
      }

    },
    //降落
    clickDown(info) {
      this.taskList.forEach(v => {
        if (v.id === info.id) {
          v.downChecked = !v.downChecked
        }
      })
      if (this.taskList.find(v => v.id === info.id).downChecked) {
        this.downIds.push(info.id)
      } else {
        this.downIds = this.downIds.filter(v => v !== info.id)
      }
      // if(!this.startIds.includes(info.id)){
      if (true) {
        let data = {
          command: 1,
          orderID: info.planSerial,
          uasID: info.uavSerial,
          uasModel: info.uavModel
        };
        this.postJsonRequest("/uav-task-server/flightCommand/sendCommand", data).then(
          res => {
            if (res.status == 200) {
              if (res.data.code == 0) {
                this.$message.success({
                  message: "执行降落指令成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function () {
                  }
                });
              } else {
                this.$message.error({
                  message: "执行降落指令失败",
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function () {
                  }
                });
              }
            }
          }
        );
      } else {
        this.$message.error({
          message: "飞机已降落执行起飞指令失败",
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function () {
          }
        });
      }
    },
    getWeatherInfo() {
      this.getRequest(
        '/uav-task-server/weatherEquipment/queryWeatherInfo'
      ).then(
        res => {
          let data = res.data.data
          data.map(v => {
            if (v && v.info && v.weatherEquipment.name == '智汇园气象设备') {
              this.weatherInfo.temp = v.info.temp;
              this.weatherInfo.pressure = v.info.atm;
              this.weatherInfo.humidity = v.info.hum;
              this.weatherInfo.rainfall = v.info.precipitation;
              this.weatherInfo.windDirection = v.info.windDirection;
              this.weatherInfo.windSpeed = v.info.windspeed;
              const img = document.getElementById('weatherCorona');
              img.style.transform = `rotate(${360 - this.weatherInfo.windDirection}deg)`
            }

          })
        })
    },
    startVideo(v) {
      const video = v ? v : this.$refs.video;
      video.pause();
      // 检查浏览器是否支持 HLS.js
      if (Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(this.videoUrl);
        this.hls.attachMedia(video);
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play();
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        // 直接播放 HLS 流
        video.src = this.videoUrl;
        video.addEventListener('loadedmetadata', () => {
          video.play();
        });
      }
    },
    switchVideo() {
      let ele = document.getElementById('video')
      ele && ele.remove()
      this.isShowVideo = !this.isShowVideo
      this.hls.destroy();
      this.$nextTick(() => {
        if (!this.isShowVideo) {
          let ele = document.getElementById('video1')
          this.startVideo(ele)
        } else {
          let ele = document.getElementById('video2')
          this.startVideo(ele)
        }

      })
    },
    initCharts() {
      // 初始化左边栏图表
      this.rightTopChart = echarts.init(document.getElementById('rightTopChart'));
      this.drawCharts();
    },
    searchClick() {
      this.queryPlan()
    },
    //关闭视频
    closeVideo() {
      const video = this.$refs.video;
      if (this.hls) {
        this.hls.destroy(); // 断开 HLS 连接
        this.hls = null;
      }
      video.pause();
      this.isShowVideo = false
    },
    queryPlan() {
      this.getRequest(
        `/uav-task-server/plandto/queryPlanByConditionNoStatus?pagesize=100&keyWord=${this.searchTaskKeyWord}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data.list;
          if (records && records.length > 0) {
            // let simpleArray = records.map(item => ({
            //   id: item.id,
            //   planSerial: item.planSerial,
            //   uavSerial: item.uavSerial,
            //   uavModel: item.uavModel,
            //   pilot: item.pilot,
            //   type: item.type,
            //   status: item.status,
            //   airpointList: item.airpointList
            // }));
            this.taskList = records;
          } else {
            this.taskList = [];
          }
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            },
          });
        }
      });
    },
    drawCharts() {
      this.setChartOptions(this.rightTopChart, this.getLandingsLandingsStatisticsOptions());
    },
    setChartOptions(chart, options) {
      chart.setOption(options);
    },
    getLandingsLandingsStatisticsOptions() {
      return {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          icon: 'circle',
          data: ['起飞架次', '降落架次'],
          textStyle: {
            color: '#ececec',
          },
          // itemStyle: {
          //   color: '#ff8c4d', // 设置图例图标颜色
          // },
          itemGap: 15,
        },
        grid: {
          left: 10,   // 左侧边距
          right: 10,  // 右侧边距
          top: 40,    // 顶部边距
          bottom: 10, // 底部边距
          containLabel: true // 是否包含坐标轴标签
        },
        xAxis: {
          data: ['8月', '9月', '10月', '11月'],
          type: 'category',
          axisLine: {
            lineStyle: {
              color: 'rgba(214, 214, 214, 0.3)', // 设置 X 轴颜色
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(214, 214, 214, 0.3)'
              }
            },
            axisLine: {
              show: false // 隐藏右侧 Y 轴的竖线
            },
            axisLabel: {
              color: '#ececec', // Y 轴文字颜色
            },
          },
        ],
        series: [
          {
            name: '起飞架次',
            type: 'bar',
            // data: this.leftTopData,
            data: [0, 27, 10, 31],
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [

                  {offset: 1, color: 'rgba(0, 174, 255, 0)'}, // 100% 不透明色
                  {offset: 0, color: '#00aeff'}, // 0% 透明色
                ],
                global: false // 缺省为 false
              },
              borderColor: '#00aeff', // 边框颜色
              borderWidth: 2, // 边框宽度
              barBorderRadius: [10, 10, 0, 0],
            },
            barWidth: '20%',
            // yAxisIndex: 1 // 指定使用右侧 Y 轴
            yAxisIndex: 0
          },
          {
            name: '降落架次',
            type: 'bar',
            // data: this.leftTopData,
            data: [0, 7, 8, 20],
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {offset: 1, color: 'rgba(0, 255, 255, 0)'}, // 100% 不透明色
                  {offset: 0, color: '#00ffff'}, // 0% 透明色
                ],
                global: false // 缺省为 false
              },
              borderColor: '#00ffff', // 边框颜色
              borderWidth: 2, // 边框宽度
              barBorderRadius: [10, 10, 0, 0],
            },
            barWidth: '20%',
            // yAxisIndex: 1 // 指定使用右侧 Y 轴
            yAxisIndex: 0
          }
        ],
        textStyle: {
          color: '#ececec' // 全局文字颜色
        }
      };
    },
    getLandingsLandingsStatistics() {
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/flightStatistics").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            this.leftTopData = oData.data.xaxis.data.map((x, index) => [x, oData.data.series.data[index]])
            resolve()
          }
        });
      });

    },
    changeDetailOpen(v) {
      this.isDetailOpen = v
    },
    async getPageData() {
      await Promise.all([
        this.getLandingsLandingsStatistics(),
      ]);
      this.initCharts()
    },
    setTime() {
      const d = new Date();
      const dStr = this.$moment(d).format("YYYY-MM-DD HH:mm:ss");
      const dStrArr = dStr.split(" ");
      this.$data.timeInfo.currentTime = dStrArr[1];
      this.$data.timeInfo.date = dStrArr[0];
      const day = d.getDay();
      const weeks = ["星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"];
      this.$data.timeInfo.weekday = weeks[day];
    },
    handleResize() {
      this.rightTopChart.resize();
    },
  },
}
</script>
<style scoped>
@font-face {
  font-family: 'PangMenZhengDao-3';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao-3-Regular';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}


* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

#dashboardLogistics {
  z-index: 3;
  width: 100%;
  height: 100%;
}

.task-item_2d {
  margin-bottom: 16px;
  cursor: pointer;
  //width: calc(100% - 14px);
}

.taskcontent_2d {
  padding: 0 10px;
  height: 100%;
  overflow: auto;
}

.contentItem66 .emptyWrap {
  width: 100%;
  height: calc(100% - 44px);
}

.task-item_2d .executePlan {
  border: 2px solid #00ffff;
}

.task-item_2d .prePlan {
  border: 2px solid #00aeff;
}

.common .itemDetail {
  width: 6px;
  height: 10px;
  background-image: url("../../assets/img/2dmap/xiang_qing.png");
}

.common .thirdSpan {
  min-width: 40px;
}

.common .secondSpan {
  min-width: 50px;
}

.common .firstSpan {
  min-width: 90px;
}

.task-item_2d .common {
  background: rgba(1, 10, 18, 0.68);
  height: 44px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6px;
}

.task-item_2d .common:hover {
  background: rgba(0, 174, 255, 0.5);
  border: none;
}

.common .firstSpan {
  min-width: 90px;
}

.common .secondSpan {
  min-width: 50px;
}

.common .thirdSpan {
  min-width: 40px;
}

.common .itemDetail {
  width: 6px;
  height: 10px;
  background-image: url("../../assets/img/2dmap/xiang_qing.png");
}

.task-item_2d .donePlan {
  border: 2px solid #ee3f3f;
}

.task-item_2d .donePlan {
  border: 2px solid #ee3f3f;
}

.task-item_2d .prePlan {
  border: 2px solid #00aeff;
}

.task-item_2d .executePlan {
  border: 2px solid #00ffff;
}

.contentItem66 .listAll_2d {
  height: calc(100% - 84px);
  padding: 0 10px;
  //width:100%;
  overflow: auto;
  margin-top: 20px;
}

.listAll_2d .warn_2d {
  background: linear-gradient(
    90deg,
    rgba(255, 150, 0, 0.8),
    rgba(71, 160, 255, 0.2)
  );
}

.listAll_2d .alarm_2d {
  background: linear-gradient(
    90deg,
    rgba(218, 0, 1, 0.8),
    rgba(71, 160, 255, 0.11)
  );
}

.taskSearchBox {
  margin-top: 12px;
}

.taskSearchBox >>> input {
  box-sizing: border-box;
  width: calc(100% - 5px);
  height: 32px;
  background: rgba(0, 174, 255, 0.5);
  font-size: 14px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
}

.taskSearchBox >>> input::placeholder {
  color: #FFFFFF;
}

.taskSearchBox >>> .el-input__icon {
  color: #FFFFFF;
  right: 15px;
  line-height: 32px;
  cursor: pointer;

}

.taskSearchBox >>> .el-input__inner {
  color: #FFFFFF;
  border-radius: 0;
  border: none;
}

.taskSearchBox >>> .el-input__inner::placeholder {
  color: white;
}

.taskSearchBox input >>> i {
  //border: 1px solid red;
  position: absolute;
  top: 7px;
  bottom: 7px;
  right: 32px;
}

/* .mapWrap {
  z-index: 2;
  position: absolute;
  top: 73px;
  left: 0;
  width: 100%;
  height: calc(100% - 77px)
} */
.headerContent {
  z-index: 3;
  width: 100%;
  height: 72px;
  background-image: url("../../assets/img/dashboard/system_header.png");
  background-size: 100%;
  display: flex;
  justify-content: space-between;
  padding: 16px 22px 0 17px;
  position: relative;
}

.headerLeft {
  display: flex;
}

.headerBtn {
  width: 120px;
  height: 40px;
  background-image: url("../../assets/img/dashboard/menu_btn.png");
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  text-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.18);
  line-height: 40px;
  cursor: pointer;
}

.headerMiddle {
  position: absolute;
  font-size: 52px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  //text-shadow: NaNpx NaNpx 2.76px NaNpx rgba(1,9,17,0.68);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.headerLeft {
  width: 460px;
  height: 50px;
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #f0f0f0;
  letter-spacing: 1.4px;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35, 21, 0, 0.48);
  margin-top: 10px;
}

.videoWrap {
  color: white;
  background: black;
  width: calc(100% - 810px);
  height: calc(100% - 72px);
  position: absolute;
  z-index: 1;
  top: 72px;
  left: 410px;
}

.mapWrap {
  color: white;
  background: black;
  width: calc(100% - 810px);
  height: calc(100% - 88px);
  position: absolute;
  z-index: 1;
  top: 72px;
  left: 410px;
}

.videoName {
  position: absolute;
  text-align: center;
  left: 50%;
  top: 10px;
  transform: translateX(-50%);
  font-size: 26px;
}

.videoClose {
  right: 5px;
  top: 5px;
  position: absolute;
  text-align: right;
  margin: 5px 5px 0 0;
  cursor: pointer;
  z-index: 6;
}

.contentWrap {
  position: relative;
  height: calc(100% - 72px);
  background-color: black;
}

.leftContent {
  background: url("../../assets/img/dashboard/pop_bg_left.png") center no-repeat;
  height: 100%;
  width: 410px;
  background-size: 400px 98%;
  position: absolute;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.rightContent {
  background: url("../../assets/img/dashboard/pop_bg_right.png") center no-repeat;
  background-size: 400px 98%;
  height: 100%;
  width: 400px;
  position: absolute;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.leftContent {
  top: 0;
  left: 0;
  z-index: 4;

}

.rightContent {
  top: 0;
  right: 0;
  z-index: 4;

}

.contentItem {
  flex: 33;
  min-height: 325px;
  display: flex;
  flex-direction: column;
}

.contentItem66 {
  flex: 66;
  min-height: 325px;
  display: flex;
  flex-direction: column;
}

.itemTitle {
  height: 50px;
  background: url("../../assets/img/dashboard/pop_header.png") center no-repeat;
  background-size: 92% 72%;
  padding-left: 44px;
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35, 21, 0, 0.48);
  margin-top: 12px;
}

.weatherWrap {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 84%;
  padding: 14px 19px 23px 15px;
}

.weatherTitleItemBox {
  position: absolute;
  width: 90px;
  height: 28px;
  background: url("../../assets/img/dashboard/data.png") center no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
}

.weatherLeftTopTitleItem {
  top: 14px;
  left: 23px;
}

.weatherLeftBottomTitleItem {
  bottom: 23px;
  left: 23px;
}

.weatherRightTopTitleItem {
  top: 14px;
  right: 19px;
}

.weatherRightBottomTitleItem {
  bottom: 23px;
  right: 19px;
}

.weatherItemTitle {
  width: 77px;
  text-align: center;
  margin-top: -15px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #ebebeb;
}

.weatherItemValue {
  width: 77px;
  text-align: center;
  margin-top: 14px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  color: #fff;
  margin-bottom: -5px;
}

.weatherCoronaCenter {
  background: url("../../assets/img/dashboard/pan.png") no-repeat;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 33px 0 41px 0;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: center;
  color: #ffffff;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 121px;
  height: 127px;
}

.map {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 20px;
}

.mapContainer {
  width: 362px;
  height: 242px;
}

.videoContainer {
  width: 362px;
  height: 242px;
  background: grey;
  border-radius: 6px;
}

.lineChartWrap {
  width: 100%;
  height: 100%;
}

.LandingsLandingsContentWrap {
  padding: 23px 21px 0 29px;
  height: calc(100% - 50px);
}

.alarmWraper {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
}

.alarmTitle {
  width: 90%;
  height: 40px;
  background-image: url(../../assets/img/dashboard/li_ru_gang_list.png);
  background-size: cover;
  display: flex;
  /* padding: 0 20px; */
  /* justify-content: space-between; */
  align-items: center;
  background-repeat: no-repeat;
}

.alarmNormal {
  /* width: 412px;
  height: 40px; */
  width: 370px;
  display: flex;
  /* justify-content: space-around; */
  height: 40px;
  background: rgba(255, 86, 73, 0.12);
}

/* .alarmNormal{
  border: 2px solid #7A4C2D;
} */
/* .alarmAbnormal{
  background-image: url(../../assets/img/dashboard/gao_jing_lie_biao.png);
  border: 2px solid #FF5649;
} */
.number {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
}

.item {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  line-height: 40px;
  margin-left: 5px;
}

.itemShortTime {
  width: 90px;
  /* height: 13px; */
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 40px;
  cursor: pointer;
  margin-left: 30px;
}

.itemLongTime {
  width: 200px;
  /* height: 13px; */
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  line-height: 40px;
  margin-left: 10px;
}

.types {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: left;
  color: #ff5346;
  line-height: 40px;
  width: 40px;
  margin-left: 21px;
}

.barChart {
  flex: 1;
}

.plan {
  padding: 15px 25px 35px 25px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.one {
  display: flex;
  justify-content: space-between;
}

.planState1 {
  width: 194px;
  height: 104px;
  background-image: url(../../assets/img/dashboard/xun_jian_data.png);
  background-repeat: no-repeat;
}

.planState2 {
  width: 194px;
  height: 104px;
  background-image: url(../../assets/img/dashboard/wu_liu_data.png);
  background-repeat: no-repeat;
}

.planState3 {
  width: 194px;
  height: 104px;
  background-image: url(../../assets/img/dashboard/guan_guang_data.png);
  background-repeat: no-repeat;
}

.planState4 {
  width: 194px;
  height: 104px;
  background-image: url(../../assets/img/dashboard/ying_ji_data.png);
  background-repeat: no-repeat;
}

.nums {
  width: 100%;
  height: 50%;
  font-size: 32px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: right;
  color: #ffffff;
  line-height: 82px;
  padding-right: 30px;
}

.texts {
  width: 100%;
  height: 30%;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: right;
  color: #ffffff;
  padding-right: 35px;
}

.alarmState1 {
  width: 194px;
  height: 104px;
  background-image: url(../../assets/img/dashboard/tubiao_chengse_2.png);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 17px;
}

.alarmState2 {
  width: 194px;
  height: 104px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 17px;
  background-image: url(../../assets/img/dashboard/tubiao_jinse_2.png);
}

.alarmState3 {
  width: 194px;
  height: 104px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 17px;
  background-image: url(../../assets/img/dashboard/tubiao_jinse_1.png);
}

.alarmState4 {
  width: 194px;
  height: 104px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 17px;
  background-image: url(../../assets/img/dashboard/tubiao_chengse_2.png);
  background-repeat: no-repeat;
}

.numbers {
  display: flex;
  align-items: center;
  justify-content: center;
}

.num {
  font-size: 24px;
  font-family: PangMenZhengDao, PangMenZhengDao-3;
  font-weight: 200;
  text-align: left;
  color: #ffffff;
  margin-left: 32px;
}

.span {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
}

.txts {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ebebeb;
  margin-left: 32px;
}


.planeBtns {
  min-width: 100px;
  justify-content: space-between;
  display: flex;
}

.planTobtn img {
  width: 26px;
  height: 26px;
}

.planeBtns .planTobtn span {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 35px;
  background-color: #333;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  z-index: 100;
}

.planeBtns .planTobtn:hover span {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/anchorPads.vue